import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
import ApiService from '../services/apiService';
import { themesMixin } from '../utils/themes';
export default {
  name: 'ViewResetPassword',
  mixins: [themesMixin],
  data: function data() {
    return {
      valid: false,
      loading: false,
      email: '',
      showMessage: false,
      emailRules: [function (v) {
        return !!v;
      }, function (v) {
        return /.+@.+\..+/.test(v);
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme'])), {}, {
    loginLogo: function loginLogo() {
      return this.themeGetLogoObject();
    },
    loginBackground: function loginBackground() {
      return this.themeGetBackground();
    }
  }),
  mounted: function mounted() {
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
  },
  beforeDestroy: function beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    forgotPass: function forgotPass() {
      var _this = this;

      this.loading = true;
      ApiService.resetPasswordRequest(this.email).then(function () {
        _this.$snack(_this.$i18n_t('Common.newPwdReq'), 'success');

        _this.showMessage = true;

        _this.$router.push('/');
      }).catch(function () {
        // THIS HAS BEEN CHANGED DUE TO PENETRATION TEST SWB
        // if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
        //   this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        // } else {
        // this.$snack(this.$i18n_t('Common.newPwdReqFail'), 'error');
        _this.$snack(_this.$i18n_t('Common.newPwdReq'), 'success');

        _this.showMessage = true;

        _this.$router.push('/'); //}

      }).finally(function () {
        _this.loading = false;
      });
    }
  })
};